import { Record } from 'immutable';
const ProductArea = Record({
  name: '',
  id: 0
}, 'ProductArea');
ProductArea.fromJS = obj => new ProductArea(Object.assign({}, obj));
export default ProductArea;